jQuery.noConflict();

var plauditConfig = (function($){
	return {
		body: $('body'),
		html: $('html'),
		win: $(window)
	};
})(jQuery);


var plauditUI = (function($){
	"use strict";

	return {
		common: function(){
			var win = plauditConfig.win
				,body = plauditConfig.body;

			// Scroll - Add class when scrolled
			var scrollCSS = "scrolled";
			function scrollEventHandler () {
				if ( win.scrollTop() < 85 ) {
					body.removeClass( scrollCSS );
				} else {
					body.addClass( scrollCSS );
				}
			}
			win.on('scroll.addClass', scrollEventHandler);
		} // common()

		,lazyLoad: function() {
			var $pagination			= $('.pagination-area .pagination')
				,$paginationItems	= $(".pagination-items")
				,$more				= $pagination.find('.next');

			if ( !$more.length) return;

			var win = plauditConfig.win
				,currentlyLoading = false
				,$loadingIndicator = $("<div class='loading-indicator'><i></i><span>Loading Content</span></div>");

			$pagination.before($loadingIndicator);
			$loadingIndicator.hide();

			var loadNextPage = function() {
				if (currentlyLoading) {
					return false;
				}

				var loadHref = $more.attr('href');
				if ( typeof loadHref === 'undefined' || !loadHref.length ) {
					return false;
				}

				currentlyLoading = true;
				$loadingIndicator.stop(true).delay(100).fadeIn( 400 );

				$.ajax({ url: loadHref, cache: false })
					.done(function( html ) {
						$loadingIndicator.stop(true).fadeOut( 100 );

						var $html = $(html);
						var $area = $html.find(".pagination-items");
						var $target = $area.children().appendTo('.pagination-items');

						plauditUI.mainGrid.append( $target );

						var newMore = $html.find('.pagination .next');
						if (newMore.hasClass('disabled')) {
							$more.attr('href', "");
						} else {
							$more.attr('href', newMore.attr('href'));
						}

						currentlyLoading = false;
					});

			}

			var loadNextPageOnScroll = function(e) {
				var scrollY = win.scrollTop() + win.height();
				var bottomOfPaginationItems = $paginationItems.offset().top + $paginationItems.height();
				if (bottomOfPaginationItems < scrollY) {
					loadNextPage();
				}
			};

			win.scroll( loadNextPageOnScroll );
			win.resize( loadNextPageOnScroll );
			loadNextPageOnScroll();
		} // lazyLoad()



		,animBoxesIn: (function(){
			function addLoadedClass() {
				this.addClass("imgLoaded");
				this.parent(".boxImage").addClass("imgLoaded");
			}
			var boxReadyClass = "boxReady";

			var pub = {
				init: function () {
					// Grid boxes
					var $gridBoxes = $(".box-grid .box");

					if ($gridBoxes.length === 0) {
						return;
					}

					var $sponsorBox = $(".box-sponsor");

					$gridBoxes.add($sponsorBox).addClass(boxReadyClass);

					plaudit.ImageUtil.WhenImagesLoaded({
						elems: $(".boxImage > img"),
						onComplete:	addLoadedClass
					});

					/* No longer being used. Should remove not only the following but the CSS and unused templates associated with it.
					------------------------------------------------------------------------------------------------------------------ */
					// Become a Sponsor image, and images on Jobs and Membership pages
					plaudit.ImageUtil.WhenImagesLoaded({
						elems: $( ".__sponsors img.ctaImage, .__membership section > img, #jobs-stripe > img" ),
						onComplete:	addLoadedClass
					});
				}
			};

			return pub;
		})() // animBoxesIn()

		,mainMenu: (function(){
			var responsiveMenu = null
				,$page = null
				,$menu = null
				,$nodesWithChildren = null
				,nodeExpandClass = "nodeExpanded"
				,$menuSecondary = null
				,$menuSecondaryItems = null
				,$triggers = null;

			var onEnable = function() {
				this.close(true);
			};
			var onDisable = function() {
				this.close(true);
				$menu.css({top: ""});
			};
			var onOpen = function() {
				$page.width( $page.width() );
				resetNodeStyling( this );

				$menu.stop(true).animate( { top: 0 }, 300, "easeInOutQuad" );
			};
			var onClose = function() {
				$page.width( "auto" );
				resetNodeStyling( this );

				if( this.isEnabled() ) {
					$menu.css({"max-height":"none"});
					var props = { top: 0-$menu.outerHeight()+$triggers.outerHeight() };
					$menu.css({"max-height":""});

					if ( this.isOpen() ) {
						$menu
							.stop(true)
							.css( { maxHeight: "none" } )
							.animate( props, 300, "easeOutQuad", function() { $(this).css( { maxHeight: "" } ) });
					} else {
						// If it is not "isOpen" and this method is being called it was forced and it should not animate.
						$menu.css( props );
					}
				}
			};
			var onResize = function() {
				if ( this.isOpen() ) {
					$page.width( "auto" );
				}
			};

			var resetNodeStyling = function( responsiveMenu, isEnabled ) {
				isEnabled = (typeof isEnabled === "undefined")? responsiveMenu.isEnabled() : isEnabled;

				$menu
					.css({height: "", maxHeight: ""})
					.find("ul, li")
						.stop(true)
						.removeAttr('style');

				$nodesWithChildren.removeClass( nodeExpandClass );

				var $childrenContainers = $nodesWithChildren.find("> ul");
				if( isEnabled ) {
					$childrenContainers.css({display: "none"});
				} else {
					$childrenContainers.css({display: ""});
				}
			};

			var litmusRegExp = new RegExp('[\"\']*responsiveMenuEnabled[\"\']*');
			var enableLitmus = function() {
				if( window.getComputedStyle ) {
					var style = window.getComputedStyle( $menu.get(0), ":before" );
					var value = style.getPropertyValue("content");
					return litmusRegExp.test(value);
				}
				return false;
			};


			var nodesWithChildrenClickHandler = function(ev) {
				if( !responsiveMenu.isEnabled() ) return;

				ev.preventDefault();

				var $node = $(this).parent()
					,$siblings	= $node.siblings()
					,$childrenContainer = $node.find("> ul");

				if ( $node.hasClass(nodeExpandClass) ) {

					// Remove class and hide children immediately
					$node.removeClass(		nodeExpandClass );
					$childrenContainer.css(	{ display: "none" } );

					// Fade in siblings while animating them to their original position.
					$siblings.add($menuSecondaryItems)
						.stop(true)
						.css(		{ position: "relative", top: 0, left: -20, opacity: 0, display: "" })
						.animate(	{ opacity: 1, left: 0 }, 200, "easeOutQuad",
								function() {
									$(this).css({ position: "", opacity: "", left: "", display: "" });
									resetNodeStyling( responsiveMenu, true );
								}
						);
					$menuSecondary
						.stop(true)
						.css(		{ opacity: 0, display: "" } )
						.animate(	{ opacity: 1}, 100, "easeOutQuad",
									function() {$(this).removeAttr('style'); }
						);

				} else {

					resetNodeStyling( responsiveMenu, true );

					// Give a few things absolute positions, and, first, set the height of menu since it won't have content.
					$menu.css({height: $menu.outerHeight()});
					$siblings.add($menuSecondaryItems).add($menuSecondary).add($node)
						.css(		{
										top: function()	{ return $(this).position().top; }
										,left: 0
									}
						)
						.css(		{	position: "absolute" });

					// Fade out siblings while animating them to the left
					$siblings.add($menuSecondaryItems)
						.css(		{ opacity: 1 } )
						.animate(	{ opacity: 0, left: "-=20" }, 400, "easeOutQuad",
									function() {$(this).css({ display: "none" }); }
						);
					$menuSecondary
						.css(		{ opacity: 1 } )
						.animate(	{ opacity: 0}, 200, "easeOutQuad",
									function() {$(this).css({ display: "none" }); }
						);

					// Animate the clicked node to the top of the menu
					$node
						.addClass(	nodeExpandClass )
						.delay(		200 )
						.animate(	{ top: 0 }, 200, "easeInOutQuad",
							function(){
								$node.removeAttr('style');

								// Animate the menu to the size needed for it's new content.
								var currentHeight = $menu.outerHeight();
								$menu.css({height: "auto"});
								var newHeight = $menu.outerHeight();
								$menu
									.css(		{height: currentHeight})
									.animate(	{ height: newHeight }, 200, "easeOutQuad", function() {
										$(this).css( {height: "auto"} );
									});
							}
						);

					// Fade children in
					$childrenContainer
						.delay(200)
						.css(		{display: "", opacity: 0})
						.animate(	{ opacity: 1 }, 400, "easeInOutQuad");

				}

			}; // nodesWithChildrenClickHandler()


			var pub = {
				init:  function( pageCover ) {
					// Store references
					$page = $("#main, #foot, .triggers");
					$menu = $("#menu");
					$nodesWithChildren = $menu.find(".hasChildren");
					$menuSecondary = $menu.find(".menu-secondary");
					$menuSecondaryItems = $menu.find(".menu-secondary > li");
					$triggers = $(".triggers");

					// Setup responsive menu
					var config = {
						noJsOpenHash:		"#menu"				
						,openStyle:			"menu-open"
						,openButtons:		"#menu-trigger"
						,closeButtons:		"#head-trigger"
						,toggleButtons:		null				
						,pageCover:			pageCover
						,onOpen:			onOpen
						,onClose:			onClose
						,enableLitmus:		enableLitmus
						,onEnable:			onEnable
						,onDisable:			onDisable
						,onResize:			onResize
					};
					responsiveMenu = new plaudit.ResponsiveMenu(config);

					// Setup click handler for nodes with children
					$nodesWithChildren.find("> a").on("click", nodesWithChildrenClickHandler);

					$menu.css( "visibility", "visible" );
				}
				,isOpen:  function() {
					return (responsiveMenu !== null && responsiveMenu.isOpen());
				}
			};

			return pub;
		})() // mainMenu{}



		,sponsors: function(){

			var getPointerEvent = function(event) {
				return event.originalEvent.targetTouches ? event.originalEvent.targetTouches[0] : event;
			};

			function setupScrollContainer( $container, $content, $left, $right ) {
				var intervalID = null,
					interval = 10,
					disabledClass = 'disabled',
					lastPointX = null,
					dragged = false,
					currentX = 0;

				var getMaxLeft = function() {
					return 0 - $content.innerWidth() + $container.width();
				};
				var updateStyle = function(maxLeft) {
					maxLeft	= typeof maxLeft !== "undefined" ?	maxLeft : getMaxLeft();

					$left.toggleClass(disabledClass, currentX >= 0);
					$right.toggleClass(disabledClass, currentX <= maxLeft);
				};
				var scrollTo = function(left) {
					var maxLeft = getMaxLeft();
					
					if (left <= maxLeft) {
						left = maxLeft;
					} else if (left > 0) {
						left = 0;
					}
					if (currentX != left) {
						currentX = left;
						$content.css( 'transform', 'translateX(' + left + 'px)' );
						updateStyle(maxLeft);
					}
				};
				var scrollBy = function( amount ) {
					scrollTo( currentX + amount );
				};
				var scrollLeft = function() {
					scrollBy( 5 );
				};
				var scrollRight = function() {
					scrollBy( -5 );
				};
				var stopScroll = function(ev) {
					if ( clearInterval !== null ) {
						clearInterval( intervalID );
						intervalID = null;
					}
					lastPointX = null;
				};

				$container
					.on('mousedown touchstart', function(ev){
						dragged = false;
						lastPointX = getPointerEvent(ev).pageX;
					})
					.on('mouseup mouseleave touchend touchcancel', stopScroll)
					.on('touchmove mousemove',function(ev) {
						if ( lastPointX !== null ) {
							dragged = true;
							var curPointerX = getPointerEvent(ev).pageX;
							scrollBy( curPointerX - lastPointX );
							lastPointX = curPointerX;
							ev.stopPropagation();
							return false;
						}
					});

				$left
					.on('mouseenter touchstart', function(ev){
						intervalID = setInterval(scrollLeft, interval);
						ev.stopPropagation();
						ev.preventDefault();
						return false;
					})
					.on('mouseleave touchend touchcancel', stopScroll)
					.on('click', function(ev) {
						ev.stopPropagation();
						ev.preventDefault();
						return false;
					});

				$right
					.on('mouseenter touchstart', function(ev){
						intervalID = setInterval(scrollRight, interval);
						ev.stopPropagation();
						ev.preventDefault();
						return false;
					})
					.on('mouseleave touchend touchcancel', stopScroll)
					.on('click', function(ev) {
						ev.stopPropagation();
						ev.preventDefault();
						return false;
					});

				$content.find('a')
					.on('dragstart', function(ev){
						ev.stopPropagation();
						return false;
					})
					.on('click', function(ev){
						if ( dragged ) {
							stopScroll(ev);
							ev.stopPropagation();
							return false;
						}
					});

				// Update style immediately, when images are loaded and when window resizes
				updateStyle();
				var loadedCount = 0,
					$images = $content.find('img'),
					imageCount = $images.length;
				$images.on('load', function(){
					loadedCount ++;
					if (loadedCount >= imageCount) {
						setupScrollContainer( $container, $content, $left, $right );
					}
				});
				$(window).resize(updateStyle);
			};

			var $marquee = $('.marquee-wrap');
			$marquee.each(function( i, container ){
				var controls = '\
					<a class="marquee-arrow marquee-prev"><i class="icon-circle-chevron-left"></i></a>\
					<a class="marquee-arrow marquee-next"><i class="icon-circle-chevron-right"></i></a>\
				';
				var $container = $(container).prepend(controls);
				var $left	= $('.marquee-prev', $container);
				var $right	= $('.marquee-next', $container);
				var $content	= $('.marquee', $container);
				setupScrollContainer( $container, $content, $left, $right );
			});
		} // end sponsors



		,carousel: function( options ) {
			var items				= options.items					// No default. Will exit silently.
				,slideDuration		= options.slideDuration			|| 3000
				,transitionDuration	= options.transitionDuration	|| 400
				,randomizeOrder		= !!options.randomizeOrder; 	// Default false

			if ( typeof items === "undefined" || !items.length ) return;

			var slideMgr = new plaudit.SlideManager({
				slides:				items
				,randomizeOrder:	randomizeOrder
				,onChange:			onSlideChange
			});

			var watch = new plaudit.Stopwatch({
				lapTime: 			slideDuration
				,onLap:				function() { slideMgr.next(); }
			});
			watch.start();

			function onSlideChange( data ) {
				var oldSlide = data.currentSlide
					,newSlide = data.newSlide;

				$(oldSlide)
					.stop(true)
					.css( {"z-index": 5} )
					.animate( { opacity: 0 }, transitionDuration, "easeInOutCubic" );
				$(newSlide)
					.stop(true)
					.css( {"z-index": 10, opacity: 0} )
					.animate( { opacity: 1 }, transitionDuration, "easeInOutCubic" );
			}

			items.parent()
				.on('mouseenter touchstart', function(ev){
					watch.pause();
				})
				.on('mouseleave touchend touchcancel', function(ev){
					watch.resume();
				});
		} // carousel



		,socialCarousel: function() {
			plauditUI.carousel({
				items:				$('#social-carousel').find('a')
				,randomizeOrder:	true
				,transitionDuration: 1500
				,slideDuration:		4000
			});
		} // socialCarousel

		,sponsorCarousel: function() {

			var setupCarousel = function( marquee, carousel, randomizeOrder ) {
				if ( carousel.length > 0 ){
					var items = $("<div/>");
					marquee.each(function(){
						var $a = $(this)
							,$img = $a.find("> img");
						var code = '<a href="' + $a.attr("href") + '"><div style="background-image: url(\'' + $img.attr("src") + '\');"></div></a>';
						items.append( code );
					});
					carousel.html( items.children() );

					plauditUI.carousel({
						items:				carousel.find("a")
						,randomizeOrder:	randomizeOrder
						,transitionDuration: 2000
						,slideDuration:		3000
					});
				}
			};

			var globalCarousel = $('#sponsor-carousel-global');
			var globalMarquee = $('#sponsor-marquee-global .marquee a');
			setupCarousel( globalMarquee, globalCarousel, false );

			var localCarousel = $('#sponsor-carousel-local');
			var localMarquee = $('#sponsor-marquee-local .marquee a');
			setupCarousel( localMarquee, localCarousel, true );

		} // sponsorCarousel

	};

})(jQuery);

//window.plauditUI = plauditUI;

jQuery(function(){
	plauditUI.common();
	//plauditUI.featureCarousel();
	// plauditUI.mainGrid.setup();
	// plauditUI.ellipsisText();

	//plauditUI.lazyLoad();

	var pageCover = new plaudit.PageCover();
	plauditUI.mainMenu.init( pageCover );

	plauditUI.animBoxesIn.init();

	plauditUI.socialCarousel();
	plauditUI.sponsors();
	plauditUI.sponsorCarousel();

	// Listen for ajax update
	document.addEventListener('jsfAjaxEvent', function(event) {
		if (event.detail.fireType === 'always') {
			plauditUI.animBoxesIn.init();
		}
	});
});
